import React from 'react';
import pure from 'recompose/pure';
import SvgIcon from '../../SvgIcon';

let ToggleCheckBox = (props) => (
  <SvgIcon {...props}>
    <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
  </SvgIcon>
);
ToggleCheckBox = pure(ToggleCheckBox);
ToggleCheckBox.displayName = 'ToggleCheckBox';
ToggleCheckBox.muiName = 'SvgIcon';

export default ToggleCheckBox;



/** WEBPACK FOOTER **
 ** ../src/svg-icons/toggle/check-box.js
 **/